export default "__VITE_ASSET__8IX_Rj6m__"